<template>
      <b-card>
        <div>
          <h5>EXPENSES</h5>
          <b-form-select v-model="selectedDateRange" @change="onDateRangeChange" style="float:right">
            <option v-for="(type) in getDateRangeNoCustom" :key="type" :value="type">  
              {{type}}
            </option>
          </b-form-select>
        </div>
        <div v-if="isLoadingWidget">
          <b-spinner variant="primary" label="Text Centered" v-if="isLoadingWidget"></b-spinner>  
        </div>    

        <div v-else>

          <doughnut-chart :chart-data="expensesData" v-if="loadedChart" :key="componentKey"></doughnut-chart>
        </div>
      </b-card>  
    
</template>

<script>
  import DoughnutChart from './../extensions/DoughnutChart.js'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions } from 'vuex';

  export default {
    components: {
      DoughnutChart
    },
    data () {
      return {
        datacollection: null,
        selectedDateRange: REQUEST_DATE.LAST_30_DAYS,
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        filters: {
          from: null,
          to: null,
          token: 'SALES'
        },
        loadedChart: false,
        expensesData: {
          datasets: [{
            data: [30,10, 20]
          }],

          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: [
              'Purchases',
              'In House Expenses',
              'Fees'
          ],
          backgroundColor: [
                '#3e95cd',
                '#3e95cf'
            ],
          borderColor: [
               '#3e95cd',
                '#3e95cf'
          ],
          borderWidth: 1
        },
        options: {
          responsive: true,
          maintainAspectRatio: false
        },
        arrDates: [],
        componentKey: 0,
        isLoadingWidget: true
      }
    },
    computed: {
      getDateRangeNoCustom() {
        let range = this.dateRangeTypes;
        delete range["CUSTOM"]

        return range;
      }
    },
    mounted () {
      this.isLoadingWidget = true;
      // this.onDateRangeChange();
      const { dateFrom, dateTo } = getDatesFromRangeString(REQUEST_DATE.LAST_30_DAYS);
      this.arrDates = generateListofDates(REQUEST_DATE.LAST_30_DAYS);
      
      Object.assign(this.filters, {
        from: dateFrom,
        to: dateTo,
      });

      this.fillData().then(() => { this.isLoadingWidget = false });
    },
    methods: {
      ...mapActions('dashboard', ['getData']),
      async fillData () {
        this.loadedChart = false;
        await this.getData(JSON.stringify(this.filters)).then((res) => {
          if (res != null && res.length > 0) {
            // this.salesData = {
            //   labels: this.arrDates,
            //   datasets: [{
            //     data: res.map(d => ({
            //       x: dateToDay(d.date),
            //       y: d.amount
            //     })),
            //     label: this.selectedDateRange,
            //     borderColor: "#3e95cd",
            //     fill: false
            //   }]
            }
            this.componentKey += 1;
            // console.log(this.salesData, "Sales Data")
          }
        )
        this.loadedChart = true;
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      onDateRangeChange(value) {  
        if (value === REQUEST_DATE.CUSTOM) {
          this.filters.dateFrom = null;
          this.filters.To = null;
        } else {
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.arrDates = generateListofDates(value);
          console.log(value, this.arrDates, "Value value")
          Object.assign(this.filters, {
            from: dateFrom,
            to: dateTo,
          });

          this.fillData();
        }
        this.selectedDateRange = value;
      }
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>